// import { TextField } from "./text-field";

// export default TextField;

export const EventHooks = {
  OnKeyup: 'OnKeyup',
  OnBlur: 'OnBlur',
  Immediate: 'Immediate',
};

export const createTextFieldConfig = ({
  box,
  controlStyle = 'box',
  disabled,
  height,
  id,
  immediateValidation,
  isModel,
  maximizeOnValue,
  options,
  password,
  placeholder,
  required,
  showEditIconOnHover,
  showValidationIcons,
  statusInside,
  textarea,
  type,
  typeahead,
  validationEvent,
  validators,
  value,
  valueChangedEvent,
}) => {

  if (!TextFieldStyles.includes(controlStyle)) {
    throw Error(`${controlStyle} is not a valid Textfield Style. Provide a valid TextField style.`);
  }
  
  if (box) {
    // if config box is true - the style will be "Box"
    controlStyle = 'box';
  }

  return {
    box,
    controlStyle,
    disabled,
    height,
    id,
    immediateValidation,
    isModel,
    maximizeOnValue,
    options,
    password,
    placeholder,
    required,
    showEditIconOnHover,
    showValidationIcons,
    statusInside,
    textarea,
    type,
    typeahead,
    validationEvent,
    validators,
    value,
    valueChangedEvent,
  };
}


export const TextFieldStyles = [
  'box',
  'readonly',
  'default',
]

export const defaultTextFieldConfig = () => {
  return createTextFieldConfig({
    height: 42,
    showEditIconOnHover: false,
    box: true,
    showValidationIcons: false,

    validationEvent: EventHooks.OnBlur,
    valueChangedEvent: EventHooks.OnBlur,
  });
}


export const createValidator = ({
  name = 'default',
  validatorFn = (str) => true,
  errorMessage = 'Default Error Message'
} = {}) => {
  return {
    name,
    validatorFn,
    errorMessage
  }
}

export const validate = (validators = [createValidator()]) => (value = '') => {
  const errors = [];
  validators.forEach(v => {
    if (v.validatorFn && !v.validatorFn(value)) {
      errors.push(v);
    }
  });

  return {
    valid: errors.length === 0,
    errors,
    errorMessages: errors.map(e => e.errorMessage)
  }
}


export const resultValidity = (validationResult) => {
  return Object.values(validationResult).every(e => e.valid);
}

const objectExists = (data) => { 
  if (typeof data === 'number') {
    if (isNaN(data)) {
      return false;
    } else {
      return true;
    }
  } else if (typeof data == 'object') {
    if (data.length === 0) {
      return false;
    } else {
      if (Object.keys(data).length > 0) {
        return true;
      } else {
        return false;
      }
    }
  } else  {
    return data ? true : false
  }
};


export const stringRequired = str => str && str.length > 0;


const requiredValidator = createValidator();

const maxLength = len => str => (stringRequired(str) && str.length <= len) ? true : false;
const minLength = len => str => (stringRequired(str) && str.length >= len) ? true : false;

const minLen3 = minLength(3);
const maxLen7 = maxLength(7);

const demoValidatorsList = [
  createValidator({
    name: 'Max Length',
    errorMessage: 'Max length cannot be more than 7',
    validatorFn: maxLen7
  }),
  createValidator({
    name: 'Min Length',
    errorMessage: 'Length cannot be less than 3',
    validatorFn: minLen3
  }),
];




const demoValidator = validate(demoValidatorsList);

// console.log(demoValidator('23dawdw'))